import { render, staticRenderFns } from "./MarketplaceWarehouses.vue?vue&type=template&id=bbfc398c&scoped=true&"
import script from "./MarketplaceWarehouses.vue?vue&type=script&lang=js&"
export * from "./MarketplaceWarehouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfc398c",
  null
  
)

export default component.exports